import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { resolveColor, SYMBOL_MAP } from "../blockTypeConstants";

const CardGridPreview = ({ blockItems, colorOptions = [] }) => {
    return (
        <div className="preview-grid">
            {blockItems
                .filter((item) => {
                    const title = item?.blockTitle || item?.title || item?.label || "";
                    const value = item?.value || item?.metricValue || "";
                    return String(title).trim().length > 0 || String(value).trim().length > 0;
                })
                .map((item, idx) => {
                    const iconType = item?.iconType || item?.prefixType || item?.bulletType || "dot";
                    const iconColor = resolveColor(item?.iconColor || item?.barColor || item?.bulletColor, colorOptions);
                    const marker = iconType === "number" ? `${idx + 1}.` : SYMBOL_MAP[iconType] || "•";
                    const title = item?.blockTitle || item?.title || item?.label || "";
                    const value = item?.value || item?.metricValue || "";

                    return (
                        <div className="preview-card-item" key={`${title || "card"}-${idx}`}>
                            <div className="card-grid-icon" style={{ color: iconColor }}>
                                {iconType === "check" ? <CheckCircleOutlined /> : <span className="card-grid-symbol">{marker}</span>}
                            </div>
                            <p className="card-grid-value">{value}</p>
                            <label className="card-grid-label">{title}</label>
                        </div>
                    );
                })}
        </div>
    );
};

export default CardGridPreview;
